/**
 * Cart drawer — open/close + shared CartSection refresh.
 */
(function () {
  'use strict';

  function CartDrawer(sectionEl) {
    this.sectionEl = sectionEl;
    this.drawer = sectionEl.querySelector('[data-ts-cart-drawer]');
    this.lastFocus = null;
    this.closeTimer = null;

    if (!this.drawer) return;

    if (!sectionEl.dataset.sectionId) {
      sectionEl.dataset.sectionId = this.drawer.getAttribute('data-section-id') ||
        sectionEl.id.replace('shopify-section-', '');
    }

    if (window.tsCart && window.tsCart.CartSection) {
      this.cart = new window.tsCart.CartSection(this.drawer, {
        source: 'cart-drawer',
        enableNote: false,
        enableExpand: false
      });
    }

    this.bindChrome();
    this.bindUpdated();
  }

  CartDrawer.prototype.bindChrome = function () {
    var self = this;

    this.drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-ts-cart-close]')) {
        event.preventDefault();
        self.close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.isOpen()) self.close();
    });
  };

  CartDrawer.prototype.bindUpdated = function () {
    var self = this;
    document.addEventListener('ts:cart:updated', function (event) {
      var detail = event.detail || {};
      if (detail.open) self.open();
    });
    document.addEventListener('ts:cart:open', function (event) {
      var detail = event.detail || {};
      if (detail.trigger) self.lastFocus = detail.trigger;
      self.open();
    });
  };

  CartDrawer.prototype.isOpen = function () {
    return this.drawer && this.drawer.classList.contains('is-open');
  };

  CartDrawer.prototype.open = function () {
    if (!this.drawer) return;
    clearTimeout(this.closeTimer);
    this.drawer.hidden = false;
    document.documentElement.classList.add('ts-cart-drawer-open');

    var self = this;
    requestAnimationFrame(function () {
      self.drawer.classList.add('is-open');
      var closeBtn = self.drawer.querySelector('[data-ts-cart-close].ts-cart-drawer__close');
      if (closeBtn) closeBtn.focus();
    });
  };

  CartDrawer.prototype.close = function () {
    if (!this.drawer || this.drawer.hidden) return;
    this.drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ts-cart-drawer-open');

    var self = this;
    this.closeTimer = setTimeout(function () {
      self.drawer.hidden = true;
      if (self.lastFocus && typeof self.lastFocus.focus === 'function') {
        self.lastFocus.focus();
      }
    }, 300);
  };

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.cartDrawerInit === 'true') return;
    sectionEl.dataset.cartDrawerInit = 'true';
    new CartDrawer(sectionEl);
  }

  function initAll() {
    document.querySelectorAll('.section-cart-drawer-wrap').forEach(function (wrapper) {
      if (!wrapper.dataset.sectionId) {
        wrapper.dataset.sectionId = wrapper.id.replace('shopify-section-', '');
      }
      initSection(wrapper);
    });
  }

  if (document.documentElement.dataset.tsCartOpenBound !== 'true') {
    document.documentElement.dataset.tsCartOpenBound = 'true';
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ts-cart-open]');
      if (!trigger) return;
      if (!document.querySelector('[data-ts-cart-drawer]')) return;
      event.preventDefault();
      document.dispatchEvent(
        new CustomEvent('ts:cart:open', { bubbles: true, detail: { trigger: trigger } })
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var wrapper = event.target.closest ? event.target.closest('.section-cart-drawer-wrap') : null;
    if (!wrapper && event.target.classList && event.target.classList.contains('section-cart-drawer-wrap')) {
      wrapper = event.target;
    }
    if (wrapper) {
      wrapper.dataset.cartDrawerInit = '';
      initSection(wrapper);
    }
  });
})();
